import { render, staticRenderFns } from "./Consents.vue?vue&type=template&id=7d0c4f24&scoped=true"
import script from "./Consents.vue?vue&type=script&lang=js"
export * from "./Consents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0c4f24",
  null
  
)

export default component.exports